import { createAuthClient } from "better-auth/client";

let _client: ReturnType<typeof createAuthClient> | null = null;

/** Browser-only Better Auth client (change password, session, etc.). */
export function getBrowserAuthClient() {
  if (typeof window === "undefined") return null;
  if (!_client) {
    _client = createAuthClient({
      baseURL: window.location.origin,
      basePath: "/api/auth",
    });
  }
  return _client;
}
